'use client'

import { useState } from 'react'
import { Control, useController } from 'react-hook-form'

import { gt } from '~/lib/gt'

import styles from './Checkbox.module.css'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode
  labelAddition?: string
  indeterminate?: boolean
  disabled?: boolean
  showMore?: React.ReactNode
  error?: boolean
  control: Control<any>
  name: string
}

const CheckboxView: React.FC<CheckboxProps> = ({
  label,
  labelAddition,
  disabled,
  showMore,
  indeterminate: defaultIndeterminate,
  error = false,
  control,
  name,
  ...props
}) => {
  const [expand, setExpand] = useState(false)
  const {
    field: { value: checked, onChange },
  } = useController({
    name,
    control,
    defaultValue: false,
  })
  const [isIndeterminate, setIsIndeterminate] = useState(defaultIndeterminate)
  const icon = isIndeterminate ? 'indeterminate' : 'check-bold'

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isIndeterminate) {
      setIsIndeterminate(false)
    }
    onChange(event.target.checked)
  }

  return (
    <label className={`${styles.checkboxField} ${disabled ? styles.disabled : ''} ${error ? styles.error : ''}`}>
      <div className={`${styles.checkboxBox} ${checked ? styles.checked : ''} ${disabled ? styles.disabled : ''}`}>
        {(checked || isIndeterminate) && <span className={`${styles.checkboxIcon} ${styles[icon]}`}>✔️</span>}
      </div>
      <div className={styles.label}>
        {label}
        {labelAddition && <span className={styles.labelAddition}>&nbsp;{labelAddition}</span>}
        {showMore && (
          <>
            {expand && <span className={styles.labelExpanded}> {showMore}</span>}
            <span
              className={styles.showMore}
              onClick={event => {
                event.stopPropagation()
                event.preventDefault()
                setExpand(!expand)
              }}>
              {' '}
              {expand ? gt.tp('Common', 'Hide') : gt.tp('Common', 'Expand')}
            </span>
          </>
        )}
      </div>
      <input {...props} type='checkbox' checked={checked} onChange={handleChange} className={styles.hiddenInput} />
    </label>
  )
}

export default CheckboxView
